import {ActionReducer, ActionReducerMap} from '@ngrx/store';
import * as fromProfile from '../reducers/profile.reducer';
import {combineReducers} from '@ngrx/store';

export interface ProfileState {
    profile: fromProfile.ProfileState;
}

export const reducers: ActionReducerMap<ProfileState> = {
    profile: fromProfile.reducer,
};

export const reducer: ActionReducer<ProfileState> = combineReducers(reducers);




// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/profile/store/reducers/index.ts